module.exports = __webpack_public_path__ + "img/tag-tienes.04a39ad7.png";